import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, ArrowRight, Play } from "lucide-react";
import { fetchConfig } from "../lib/api";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Demonstration() {
  const { data: config } = useQuery({ queryKey: ["config"], queryFn: fetchConfig });
  const url = config?.vsl_video_url;

  return (
    <div>
      <Seo routeKey="/pilote" path="/demonstration" title="La démonstration — 9 minutes, sans coupure | VIRALYA" description="Le circuit qui tourne, en neuf minutes, sans coupure. Pas de VSL, pas de gate." />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <span className="eyebrow"><span className="sq" />Démonstration</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>Le circuit qui tourne, en 9 minutes, sans coupure</h1>
          <p className="lead" style={{ marginBottom: "1.5rem" }}>Pas de montage vendeur, pas de compte à rebours. Une seule prise, du début à la fin.</p>

          <div className="vsl-player" data-testid="demo-frame">
            {url ? (
              <video controls playsInline preload="metadata" src={url} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : (
              <div className="vsl-play"><button aria-label="Vidéo à venir" disabled><Play size={30} fill="currentColor" /></button></div>
            )}
          </div>
          {!url && <p className="muted center" style={{ marginTop: "1rem", fontFamily: "var(--font-mono)", fontSize: "0.82rem" }}>Vidéo en préparation — l'enregistrement complet sera publié ici.</p>}

          <div className="center" style={{ marginTop: "2rem" }}>
            <Link to="/pilote" className="btn btn--primary" data-testid="demo-cta">Essayer 7 jours — 49 CHF <ArrowRight size={16} /></Link>
          </div>
          <p className="muted center" style={{ marginTop: "2.5rem", fontSize: "0.82rem", maxWidth: "60ch", marginLeft: "auto", marginRight: "auto" }} data-testid="demo-darven-credit">L'infrastructure complète de VIRALYA a été mise en place par Darven, qui gère également notre acquisition client.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
